import { createTheme } from '@mui/material/styles';
import Colour from '../../styles/Colour';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const getTheme = (mode) => {
  let ParseFn = (value) => {
    if (value) {
      return JSON.parse(value);
    }
    return;
  };
  let selectedThemeId =
    ParseFn(ParseFn(localStorage.getItem('persist:root'))?.userPrefrenceandReducer)?.userPreference?.find(
      (elem) => elem?.attributetypecd == 'SelectedTheme'
    )?.attributevalue || 1;

  console.log({ selectedThemeId });
  let Colors;
  for (let key in Colour) {
    if (Colour[key].tmId == (mode == undefined ? selectedThemeId : mode)) {
      Colors = Colour[key];
    }
  }

  return createTheme({
    palette: {
      mode: Colors?.tmId.toString().includes('9') ? 'dark' : 'light',
      // action: { active: Colors?.primary },
      // mode: 'light',
      TmId: {
        id: Colors?.tmId,
      },
      primary: {
        main: Colors?.primary,
        black: Colors?.black,
      },
      secondary: {
        main: Colors?.secondary,
      },
      tertiary: {
        main: Colors?.tertiary,
      },
      // forth: {
      //   main: Colors?.forth,
      // },
      success: {
        main: Colors?.success,
      },
      danger: {
        main: Colors?.danger,
      },
      background: {
        paper: Colors?.papperBg,
        bgpaper: Colors?.light,
        tablebg: Colors?.tableBGColor,
        tablebg1: Colors?.tableBGColor1,
        tablebg2: Colors?.tableBGColor2,
      },
      input: {
        font: Colors?.inputFieldColor,
        border: Colors?.inputFieldBorderColor,
        label: Colors?.inputLabelColor,
      },
      shadow: {
        primary: Colors?.shadow1,
        secondary: Colors?.shadow2,
        tertiary: Colors?.shadow3,
      },
      bodyGray: {
        main: Colors?.bodyGray2,
        secondary: Colors?.bodyGray1,
        tertiary: Colors?.bodyGray,
      },
      primaryRowClr: {
        main: Colors?.primaryRow,
        secondary: Colors?.activeRow,
      },
      sideBar: {
        main: Colors?.sideBar1,
        secondary: Colors?.sideBarIcon,
      },
      nav: {
        main: Colors?.nav,
        font: Colors?.navF,
      },
      text: {
        mainHead: '1rem',
        head: '20px',
        para: '14px',
        discr: '10px',
        disable: '#DDDDDD',
        Link: Colors?.linkClr,
        textClr: Colors?.FontClr == undefined ? Colors?.navF : Colors?.FontClr,
      },
    },
    typography: {
      allVariants: {
        fontSize: '14px',
        [`@media (max-width:600px)`]: {
          fontSize: '12px',
        },
        // color: Colors?.FontClr === undefined ? "black" : Colors?.FontClr,
      },
      h1: {
        fontFamily: 'Milliard Bold',
        fontSize: '18px',
        fontWeight: 'bolder',
        [`@media (max-width:600px)`]: {
          fontSize: '16px',
        },
      },
      h3: {
        fontFamily: 'Milliard Bold',
        fontSize: '14px',
        color: 'white',
        [`@media (max-width:600px)`]: {
          fontSize: '12px',
        },
      },
      body1: {
        fontSize: '1rem',
        [`@media (max-width:600px)`]: {
          fontSize: '0.875rem',
        },
      },
    },
    components: {
      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
            maxHeight: '300px', // Set maximum height for all Popovers
            overflowY: 'auto', // Enable vertical scrolling
            '&:hover::-webkit-scrollbar': {
              border: '1px solid',
              borderColor: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
            },
            '&:hover::-webkit-scrollbar-thumb': {
              border: '1px solid',
              borderColor: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
            },
            '&::-webkit-scrollbar': {
              width: '8px',
              transition: 'width 0.3s ease',
            },
            '&::-webkit-scrollbar-track': {
              background: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: Colors?.primary,
              border: '3px solid',
              borderColor: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            // This ensures that any other Paper component also respects this color
            backgroundColor: Colors?.papperBg,
            // backgroundColor:  Colors?.tmId.toString().includes("9") ? "#373843" : "white"
            // backgroundColor: "transparent"
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              color: '#4d4d4d', // text color
              backgroundColor: '#f0f0f0', // bg color when disabled
              opacity: 1, // prevent fade if you want
              cursor: 'not-allowed',
            },
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableRipple: true,
          disableElevation: true,
        },
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'primary' && {
                color: '#fff',
              }),
            textTransform: 'none',
          }),
          contained: {
            '&:focus': {
              boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
            },
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            '& .MuiTableRow-root': {
              // color: "#595C66", // Change font color of TableRow inside TableHead
            },
            '& .MuiTableCell-root': {
              // color: "#595C66", // Ensure font color is applied to TableCell as well
            },
            '& .MuiTableCell-root': {
              fontSize: '14px',
              backgroundColor: Colors.tableBGColor,
              color: 'rgba(41, 40, 40, 0.82)',
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '13px',
          },
          head: {
            fontSize: '16px',
            fontWeight: 'bold',
            color: Colors.tableCellHeadColor,
          },
          body: {
            fontSize: '13px',
            // color: Colors?.FontClr == undefined ? "black" : Colors?.FontClr
          },
          // root: {
          //     padding: "0px",
          //     "& .MuiCheckbox-root": {
          //       padding: "4px",
          //     },
          //   },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          actions: {
            marginLeft: '8px', // Optional: Adjust margin for next/prev buttons if needed
          },
          selectLabel: {
            fontSize: '1rem', // Default size
            '@media (max-width:600px)': {
              fontSize: '0.75rem', // Smaller font size for mobile
            },
          },
          displayedRows: {
            fontSize: '1rem',
            '@media (max-width:600px)': {
              fontSize: '0.75rem',
              marginLeft: '-24px', //Only for mobile and small devices
            },
          },
          select: {
            padding: '6px 10px', // Adjust padding
            borderRadius: '4px', // Add border radius
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '@media (max-width:600px)': {
              fontSize: '0.75rem',
            },
          },
          root: {
            // color: Colors?.FontClr == undefined ? "black" : Colors?.FontClr,
            '&.Mui-disabled': {
              color: '#4d4d4d', // Change the color of disabled icons in the select component
            },
          },
          toolbar: {
            '& .MuiTablePagination-actions': {
              // color: Colors?.FontClr == undefined ? "black" : Colors?.FontClr,
              '&.Mui-disabled': {
                color: '#4d4d4d', // Change the color of disabled icons in the select component
              },
            },
          },
          selectIcon: {
            // color: Colors?.FontClr == undefined ? "black" : Colors?.FontClr,
            '&.Mui-disabled': {
              color: '#4d4d4d', // Change the color of disabled icons in the select component
            },
          },
        },
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            // background: Colors?.tableBGColor,
            '&:hover': {
              color: Colors?.primary, // Global hover color
            },
            '&.Mui-active': {
              // background: Colors?.tableBGColor,
              color: Colors?.primary, // Change this to your desired active color
            },
          },
        },
      },
      MuiIconButton: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiRadio: {
        defaultProps: {
          disableRipple: true,
        },
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              color: '#4d4d4d', // custom disabled radio color
              opacity: 1, // prevent it from looking faded
            },
            padding: '0px',
            margin: '0px 5px',
            color: '#e2e4ee',
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          // disableRipple: true,
        },
        styleOverrides: {
          root: {
            color: '#919191',
            '&.Mui-checked': {
              color: 'red',
            },
            '&.Mui-disabled': {
              color: '#e2e4ee',
            },
            '&.Mui-checked.Mui-disabled': {
              color: '#e2e4ee',
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            // normal
            color: '#4d4d4d',
            // when the label itself has the disabled class
            '&.Mui-disabled': {
              color: '#4d4d4d',
              opacity: 1,
            },
          },
          root: {
            '&.Mui-disabled': {
              color: '#4d4d4d', // label color when disabled
            },
            // color: "black",
            fontSize: '12px',
          },
          //   label: {
          //   fontSize: "14px",
          // }
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-root': {
              '&:focus-within': {
                backgroundColor: '#f0f0f0', // Background color on focus
              },
            },
          },
          input: {
            fontSize: '13px',
            // color: "red", // Set the font size for input text
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          InputProps: {
            classes: {
              input: 'custom-scrollbar', // Your custom class
            },
          },
        },
        styleOverrides: {
          input: {
            fontSize: '12px',
            // color: Colors?.FontClr == undefined ? "black" : Colors?.FontClr
          },
          root: {
            '& .Mui-disabled .MuiInputLabel-root': {
              color: '#4d4d4d', // Label color when disabled
            },
            '& .MuiOutlinedInput-root': {
              '&.Mui-disabled': {
                color: '#4d4d4d', // Text color when disabled
              },
            },
            '& .MuiInputBase-root': {
              // backgroundColor: '#22272b', // Change background color of the input
            },
            '& .MuiInputBase-input': {
              // fontSize:"13px",
              color: Colors?.FontClr == undefined ? 'black' : Colors?.FontClr,
            },
            '& .MuiInputLabel-root': {
              color: Colors?.FontClr == undefined ? 'black' : Colors?.FontClr,
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: Colors?.FontClr == undefined ? 'black' : Colors?.FontClr,
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
              border: '3.5px solid #ffb74d',

              // Optional: match the shape of the input
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },

            '& .MuiInputLabel-root': {
              backgroundColor: Colors?.bodyGray2, // Prevent label from being overlapped
              zIndex: 1,
              padding: '0 4px', // Helps visually separate label from border
              left: '8px', // Optional: fine-tune label position
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          '& .MuiOutlinedInput-root.Mui-focused': {
            border: '3.5px solid #ffb74d',

            // Optional: match the shape of the input
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },

          '& .MuiInputLabel-root': {
            // backgroundColor: "#fff", // Prevent label from being overlapped
            zIndex: 1,
            padding: '0 4px', // Helps visually separate label from border
            left: '8px', // Optional: fine-tune label position
          },
          select: {
            display: 'flex',
            alignItems: 'center',
            height: '25px',
            padding: '4.5px 14px', // Adjust padding to maintain proper spacing
            minHeight: 'unset', // Ensure min-height is not overriding the height
            fontSize: '13px',
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          '& .MuiOutlinedInput-root.Mui-focused': {
            border: '3.5px solid #ffb74d',

            // Optional: match the shape of the input
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },

          '& .MuiInputLabel-root': {
            // backgroundColor: "#fff", // Prevent label from being overlapped
            zIndex: 1,
            padding: '0 4px', // Helps visually separate label from border
            left: '8px', // Optional: fine-tune label position
          },
          '& .MuiInputBase-input': {
            fontSize: '13px',
          },
          popper: {
            // zIndex: 1200,
          },
          paper: {
            // zIndex: 1200,
            backgroundColor: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
          },
          listbox: {
            // zIndex: 1200,
            backgroundColor: Colors?.bodyGray2 == undefined ? Colors?.bodyGray : Colors?.bodyGray2,
          },
          input: {
            fontSize: '13px', // Set the font size for input text in outlined variant
          },
          inputRoot: {
            height: '34px',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          '& .MuiOutlinedInput-root.Mui-focused': {
            border: '3.5px solid #ffb74d',

            // Optional: match the shape of the input
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },

          '& .MuiInputLabel-root': {
            // backgroundColor: "#fff", // Prevent label from being overlapped
            zIndex: 1,
            color: '#4d4d4d',
            padding: '0 4px', // Helps visually separate label from border
            left: '8px', // Optional: fine-tune label position
          },
          input: {
            fontSize: '12px', // Set the font size for input text in outlined variant
            // color: "#919191",
            // color: "black",
            // paddingRight: "50px",
          },
          notchedOutline: {
            borderColor: 'gray',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          '& .MuiOutlinedInput-root.Mui-focused': {
            border: '3.5px solid #ffb74d',

            // Optional: match the shape of the input
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiInputLabel-root': {
            // backgroundColor: "#fff", // Prevent label from being overlapped
            color: '#4d4d4d',
            zIndex: 1,
            padding: '0 4px', // Helps visually separate label from border
            left: '8px', // Optional: fine-tune label position
          },
          asterisk: {
            color: 'red', // Change this to your desired color
          },
          outlined: {
            // Specific for the outlined variant
            fontSize: '13px', // Set the font size for the label (placeholder when not focused)
            // color: "black",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          '& .MuiOutlinedInput-root.Mui-focused': {
            border: '3.5px solid #ffb74d',

            // Optional: match the shape of the input
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },

          '& .MuiInputLabel-root': {
            // backgroundColor: "#fff", // Prevent label from being overlapped
            color: 'black',
            zIndex: 1,
            padding: '0 4px', // Helps visually separate label from border
            left: '8px', // Optional: fine-tune label position
          },
          input: {
            '&.Mui-disabled': {
              color: '#4d4d4d', // 👈 your desired disabled text color
              WebkitTextFillColor: '#4d4d4d', // fix for Chrome/Safari
              opacity: 1, // prevent it from looking faded
            },
            '&::placeholder': {
              fontSize: '16px', // Set the font size for the placeholder
              opacity: 1, // Make sure the placeholder is fully visible
            },
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            backgroundColor: 'transparent',
            backgroundImage: 'none',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '13px',
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            '&.Mui-checked': {
              color: 'red',
            },
            '&.MuiCheckbox-root': {
              color: 'red',
            },
            '& .MuiSvgIcon-root': {
              color: 'red',
            },
          },
        },
      },
    },
    // zIndex: {
    //   drawer: 1302,
    // }

    // below code represents the break points that can have intaed of xs(0), sm(600), md(900), lg(1200), xl(1536)
    // breakpoints : {
    //     values : {
    //         mobile : 0,
    //         tablet : 768,
    //         laptop : 1024,
    //         desktop : 1200
    //     }
    // }
  });
};

export const useThemes = () => {
  const mode = useSelector(
    (state) => state?.userPrefrenceandReducer?.userPreference?.find((elem) => elem?.attributetypecd == 'SelectedTheme')?.attributevalue
  );

  console.log(mode, '*modeeee');
  const theme = useMemo(() => getTheme(mode), [mode]);
  return { theme };
};
